<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i class="fa fa-search searchBtn ml-3 mt-1" title="ძებნა"></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ორგანიზაციის დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            data-backdrop="static"
            data-keyboard="false"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      ref="addModal"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              სპეციალური ჯგუფების დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="container py-4">
              <div class="row">
                <div class="col-md-12">
                  <ul id="tabsJustified" class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        data-target="#specialGroup"
                        data-toggle="tab"
                        class="
                          nav-link
                          small
                          text-uppercase
                          modal-nav
                          pointer
                          active
                          show
                        "
                        >სპეციალური ჯგუფები</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        data-target="#specialItem"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav pointer"
                        >სპეციალური ნივთი</a
                      >
                    </li>
                  </ul>
                  <br />
                  <div id="tabsJustifiedContent" class="tab-content">
                    <div
                      id="specialGroup"
                      class="tab-pane fade"
                      v-bind:class="{ active: isActive, show: isActive }"
                    >
                      <div class="row">
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="text"
                                id="nameGeAdd"
                                class="form-control"
                                placeholder="სახელი ქართულად"
                                autofocus="autofocus"
                                v-model="specialGroup.nameGe"
                                v-on:input="$v.specialGroup.$touch"
                                v-bind:class="{
                                  'error-border': $v.specialGroup.nameGe.$error,
                                  valid:
                                    $v.specialGroup.nameGe.$dirty &&
                                    !$v.specialGroup.nameGe.$invalid,
                                }"
                              />
                              <label for="nameGeAdd">სახელი ქართულად</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="nameEnAdd"
                                class="form-control"
                                placeholder="English Name"
                                v-model="specialGroup.nameEn"
                                v-on:input="$v.specialGroup.$touch"
                                v-bind:class="{
                                  'error-border': $v.specialGroup.nameEn.$error,
                                  valid:
                                    $v.specialGroup.nameEn.$dirty &&
                                    !$v.specialGroup.nameEn.$invalid,
                                }"
                              />
                              <label for="nameEnAdd">English Name</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="nameRuAdd"
                                class="form-control"
                                placeholder="имя на русском"
                                v-model="specialGroup.nameRu"
                                v-on:input="$v.specialGroup.$touch"
                                v-bind:class="{
                                  'error-border': $v.specialGroup.nameRu.$error,
                                  valid:
                                    $v.specialGroup.nameRu.$dirty &&
                                    !$v.specialGroup.nameRu.$invalid,
                                }"
                              />
                              <label for="nameRuAdd">имя на русском</label>
                            </div>
                          </div>
                        </form>
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="number"
                                id="orderPriorityAdd"
                                class="form-control"
                                placeholder="პრიორიტეტი"
                                v-model="specialGroup.orderPriority"
                                v-on:input="$v.specialGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.specialGroup.orderPriority.$error,
                                  valid:
                                    $v.specialGroup.orderPriority.$dirty &&
                                    !$v.specialGroup.orderPriority.$invalid,
                                }"
                              />
                              <label for="orderPriorityAdd">პრიორიტეტი</label>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showAdd"
                                v-model="specialGroup.show"
                              />
                              <label class="form-check-label" for="showAdd"
                                >ჩვენება</label
                              >
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div id="specialItem" class="tab-pane fade">
                      <div class="row">
                        <autocomplete
                          :list="specialItemsArray"
                          class="ml-4"
                          :resetField="resetAutocomplete"
                          optionField="nameGe"
                          @input="onAutocompleteInput"
                          v-on:input="$v.specialGroup.$touch"
                          placeHolderValue="სპეციალური ნივთი"
                        >
                          <div slot="list-item" slot-scope="{ item }">
                            {{ item.nameGe }}
                            <br />
                            {{ item.descGe }}
                          </div>
                        </autocomplete>
                      </div>
                      <div class="row">
                        <div v-if="specialGroup.specialItems.length > 0">
                          <div
                            v-for="specialItem in specialGroup.specialItems"
                            :key="specialItem.id"
                            class="modal-card card mt-3"
                          >
                            <div class="card-body row">
                              <div class="col-11">
                                სახელი: {{ specialItem.nameGe }}
                                <br />
                                აღწერა: {{ specialItem.descGe }}
                              </div>
                              <div class="col-1">
                                <i
                                  class="fas fa-times deleteBtn"
                                  title="წაშლა"
                                  v-on:click="$v.specialGroup.$touch"
                                  @click="
                                    removeSpecialItemFormList(specialItem.id)
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              v-if="!isActiveModalPrepare"
              type="button"
              class="btn btn-success"
              :disabled="!$v.specialGroup.$dirty || $v.specialGroup.$error"
              @click="$v.specialGroup.$touch(), addSpecialGroup()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isActiveModalPrepare"
              type="button"
              class="btn btn-success"
              :disabled="!$v.specialGroup.$dirty || $v.specialGroup.$error"
              @click="$v.specialGroup.$touch(), editSpecialGroup()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">სახელი ქართულად</th>
            <th class="numeric">English Name</th>
            <th class="numeric">имя на русском</th>
            <th class="numeric">ჩვენება</th>
            <th class="numeric">რედაქტირება</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="value in specialGroupsArray"
            :key="value.id"
          >
            <td data-title="სახელი ქართულად" class="numeric">
              {{ value.nameGe }}
            </td>
            <td data-title="English Name" class="numeric">
              {{ value.nameEn }}
            </td>
            <td data-title="имя на русском" class="numeric">
              {{ value.nameRu }}
            </td>
            <td data-title="მთავარზე ჩვენება" class="numeric">
              {{ value.show }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="editFillInputs(value), modalPrepareEdit()"
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="getDeleteId(value.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              სპეციალური ჯგუფის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteSpecialGroup()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import ProductMenuGroupTemplate from "../common/ProductMenuGroupTemplate.vue";
import { required } from "vuelidate/lib/validators";

export default {
  name: "SpecialGroup",
  components: { autocomplete: ProductMenuGroupTemplate },
  data() {
    return {
      showModal: false,
      specialGroup: {
        id: "",
        nameGe: "",
        nameEn: "",
        nameRu: "",
        orderPriority: null,
        show: false,
        specialItems: [],
      },
      specialItem: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        imageSrc: null,
      },
      isActive: false,
      isActiveModalPrepare: false,
      resetAutocomplete: false,
      specialGroupsArray: [],
      specialItemsArray: [],
      specialItemsArrayEdit: [],
      selectedspecialItemsArray: [],
      specialItemsAutocompleteArray: [],
    };
  },
  validations: {
    specialGroup: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
      orderPriority: {
        required,
      },
      specialItems: {
        required,
      },
    },
  },
  async created() {
    let specialGroupResult = await this.$http.getSpecialGroup();
    this.specialGroupsArray = specialGroupResult.data.res;

    let specialItemResult = await this.$http.getSpecialItem();
    this.specialItemsArray = specialItemResult.data.res;
  },
  methods: {
    async addSpecialGroup() {
      try {
        for (let i = 0; i < this.specialGroup.specialItems.length; i++) {
          if (this.specialGroup.specialItems[i].id) {
            this.specialGroup.specialItems[i] =
              this.specialGroup.specialItems[i].id;
          }
        }
        // let data1 = new FormData()

        // data1.append('nameGe', this.product.nameGe)
        // data1.append('nameEn', this.product.nameEn)
        // data1.append('nameRu', this.product.nameRu)
        // data1.append('descGe', this.product.descGe)
        // data1.append('descEn', this.product.descEn)
        // data1.append('descRu', this.product.descRu)
        // data1.append('itemPrice', this.product.itemPrice)
        // data1.append('brandId', this.product.brandId)
        // data1.append('pointsPrice', this.product.pointsPrice)
        // data1.append('pointCorrection', this.product.pointCorrection)
        // data1.append('legalId', this.product.legalId)
        // data1.append('properties', this.product.properties)
        // data1.append('categories', this.product.categories)
        // data1.append('subCategories', this.product.subCategories)
        // data1.append('mainImage', this.product.mainImage)
        // this.product.gallery.forEach(el => {
        //   data1.append('gallery', el)
        // })

        // let data = new FormData()

        // data.append('nameGe', this.productMenuGroup.nameGe)
        // data.append('nameEn', this.productMenuGroup.nameEn)
        // data.append('nameRu', this.productMenuGroup.nameRu)
        // data.append('order', this.productMenuGroup.order)
        // data.append('prodCategoryId', this.productMenuGroup.prodCategoryId)
        // data.append('prodSubCategoryId', this.productMenuGroup.prodSubCategoryId)
        // data.append('showInSubs', this.productMenuGroup.showInSubs === null
        //   ? false
        //   : this.productMenuGroup.showInSubs)
        // data.append('showOnDashboard', this.productMenuGroup.showOnDashboard === null
        //   ? false
        //   : this.productMenuGroup.showOnDashboard)
        // data.append('showOnlyDashboard', this.productMenuGroup.showOnlyDashboard === null
        //   ? false
        //   : this.productMenuGroup.showOnlyDashboard)
        // data.append('showOnlyMain', this.productMenuGroup.showOnlyMain === null
        //   ? false
        //   : this.productMenuGroup.showOnlyMain)
        // data.append('showOnMain', this.productMenuGroup.showOnMain === null
        //   ? false
        //   : this.productMenuGroup.showOnMain)
        // data.append('products', this.productMenuGroup.products)
        let productMenuGroupObjectAdd = {
          nameGe: this.specialGroup.nameGe,
          nameEn: this.specialGroup.nameEn,
          nameRu: this.specialGroup.nameRu,
          orderPriority: this.specialGroup.orderPriority,
          show:
            this.specialGroup.show === null ? false : this.specialGroup.show,
          specialItems: this.specialGroup.specialItems,
        };

        let specialGroupAddResult = await this.$http.postSpecialGroup(
          productMenuGroupObjectAdd
        );

        if (specialGroupAddResult.data.resultCode === "200") {
          bus.$emit("success", "სპეციალური ჯგუფი წარმატებით დაემატა");
          let specialGroupResult = await this.$http.getSpecialGroup();
          this.specialGroupsArray = specialGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "სპეციალური ჯგუფის დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editSpecialGroup() {
      try {
        let productMenuGroupObjectEdit = {
          id: this.specialGroup.id,
          nameGe: this.specialGroup.nameGe,
          nameEn: this.specialGroup.nameEn,
          nameRu: this.specialGroup.nameRu,
          orderPriority: this.specialGroup.orderPriority,
          show:
            this.specialGroup.show === null ? false : this.specialGroup.show,
          specialItems: this.specialGroup.specialItems.map((x) => x.id),
        };

        let specialGroupEditResult = await this.$http.putSpecialGroup(
          productMenuGroupObjectEdit
        );

        if (specialGroupEditResult.data.resultCode === "200") {
          bus.$emit("success", "სპეციალური ჯგუფი წარმატებით დარედაქტირდა");
          let specialGroupResult = await this.$http.getSpecialGroup();
          this.specialGroupsArray = specialGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "სპეციალური ჯგუფის რედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
      this.autocomplete = !this.autocomplete;
    },
    async deleteSpecialGroup() {
      try {
        let specialGroupDeleteResult = await this.$http.deleteSpecialGroup(
          this.specialGroup.id
        );

        if (specialGroupDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის მენიუ გრუპი წარმატებით წაიშალა");
          let specialGroupResult = await this.$http.getSpecialGroup();
          this.specialGroupsArray = specialGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის მენიუ გრუპის წაშლის დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      // this.specialGroup = Object.assign({}, row)
      let specialGroupResult = await this.$http.getByIDSpecialGroup(row.id);
      this.specialGroup = specialGroupResult.data.res;

      console.log("aa", this.specialGroup);
    },
    getDeleteId(id) {
      this.specialGroup.id = id;
    },
    // async getSpecialItemsById () {
    //   for (let i = 0; i < this.specialGroup.specialItems.length; i++) {
    //     if (!this.specialGroup.specialItems[i].id) {
    //       let result = await this.$http.post(baseUrl + 'get-special-item', { id: this.specialGroup.specialItems[i] })
    //       this.specialItemsArrayEdit.push(result.data.res)
    //     } else {
    //       this.specialItemsArrayEdit.push(this.specialGroup.specialItems[i])
    //     }
    //   }
    //   console.log(specialItemsArrayEdit)
    //   return specialItemsArrayEdit
    // },
    removeSpecialItemFormList(specialItemId) {
      let specialItemIndex = this.specialGroup.specialItems.findIndex(
        (d) => d.id === specialItemId
      );
      this.specialGroup.specialItems.splice(specialItemIndex, 1);
      let selectedSpecialItemsIndex = this.selectedspecialItemsArray.findIndex(
        (d) => d.id === specialItemId
      );
      this.selectedspecialItemsArray.splice(selectedSpecialItemsIndex, 1);
    },
    onAutocompleteInput(object) {
      // console.log(object)
      this.selectedspecialItemsArray.push(object);
      this.specialGroup.specialItems.push(object);
      this.resetAutocomplete = !this.resetAutocomplete;
    },
    modalPrepareEdit() {
      this.isActiveModalPrepare = true;
      this.isActive = true;
    },
    modalPrepare() {
      this.isActiveModalPrepare = false;
      this.isActive = true;
    },
    clearData() {
      this.specialGroup.id = null;
      this.specialGroup.nameGe = "";
      this.specialGroup.nameEn = "";
      this.specialGroup.nameRu = "";
      this.specialGroup.orderPriority = null;
      this.specialGroup.show = false;
      this.specialGroup.specialItems = [];
      this.specialItem.id = null;
      this.specialItem.nameGe = "";
      this.specialItem.nameEn = "";
      this.specialItem.nameRu = "";
      this.specialItem.descGe = "";
      this.specialItem.descEn = "";
      this.specialItem.descRu = "";
      this.specialItem.imageSrc = null;
      this.resetAutocomplete = !this.resetAutocomplete;
      this.selectedspecialItemsArray = [];
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/SpecialGroup.vue